import React from 'react';
import { createRoot } from 'react-dom/client';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import AlertDialogModal from './AlertDialogModal';

const UserConfirmationPrompt = (theme) => {
  let root = null;
  const userConfirmationPrompt = React.useCallback((message, callback) => {
    const node = document.getElementById('custom-prompt');

    const cleanUp = (answer) => {
      if (root) {
        root.unmount();
        root = null;
      }
      callback(answer);
    };
    const cancel = () => cleanUp(false);
    const ok = () => cleanUp(true);
    root = createRoot(node);
    root.render(
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <AlertDialogModal
            open={true}
            handleClose={cancel}
            handleTask={ok}
            ContentText={message}
            ButtonName="yes"
          />
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }, []);
  return {
    userConfirmationPrompt,
  };
};

export default UserConfirmationPrompt;
